import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../lib/api";
import { Spinner } from "../components/Bits";
import { BlockList } from "../components/blocks/BlockRenderer";

export default function CmsPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setLoading(true);
    setNotFound(false);
    api
      .get(`/cms/pages/${slug}`)
      .then((r) => {
        setPage(r.data);
        // Update meta tags
        if (r.data?.title) document.title = `${r.data.title} – AdventureCouple.lu`;
        if (r.data?.meta_description) {
          let m = document.querySelector('meta[name="description"]');
          if (!m) {
            m = document.createElement("meta");
            m.setAttribute("name", "description");
            document.head.appendChild(m);
          }
          m.setAttribute("content", r.data.meta_description);
        }
      })
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="py-32"><Spinner /></div>;
  if (notFound) {
    return (
      <div className="py-32 px-6 text-center" data-testid="cms-page-not-found">
        <h1 className="font-display text-4xl mb-3" style={{ color: "var(--wp-olive)" }}>Seite nicht gefunden</h1>
        <p className="text-sm opacity-70">Diese Seite existiert nicht oder ist noch nicht veröffentlicht.</p>
        <a href="/" className="btn-primary inline-flex mt-6">Zur Startseite</a>
      </div>
    );
  }

  const blocks = page?.blocks || [];

  return (
    <div data-testid={`cms-page-${slug}`}>
      {blocks.length === 0 ? (
        <div className="py-24 text-center">
          <h1 className="font-display text-4xl mb-2" style={{ color: "var(--wp-olive)" }}>{page?.title}</h1>
          <p className="text-sm opacity-70">Diese Seite enthält noch keine Blöcke.</p>
        </div>
      ) : (
        <BlockList blocks={blocks} />
      )}
    </div>
  );
}
